import React, { Component } from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';
import { DRNButton } from '@traveloka/district-ui';

import temporarySystemDisruptionImage from 'common/res/images/temporarySystemDisruption/empty_state_temporary_system_disruption.png';

import R from 'common/res/R';

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    flex: 1,
    backgroundColor: R.color.background,
  },
  containerRelative: {
    flex: 1,
    backgroundColor: R.color.background,
  },
  centerContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    ...R.typography.weightBold,
    color: R.color.textPrimary,
    fontSize: R.typography.fontSize.medium,
    lineHeight: R.typography.fontSize.big,
    textAlign: 'center',
    marginTop: R.spacing.ml,
    marginBottom: R.spacing.xs,
    paddingLeft: R.spacing.s,
    paddingRight: R.spacing.s,
  },
  message: {
    color: R.color.textPrimary,
    fontSize: R.typography.fontSize.small,
    lineHeight: R.typography.fontSize.large,
    textAlign: 'center',
    paddingLeft: R.spacing.s,
    paddingRight: R.spacing.s,
  },
  ctaButton: {
    backgroundColor: R.color.uiOrangePrimary,
    margin: R.spacing.m,
  },
  image: {
    width: 170,
    height: 140,
  },
});

const defaultTitle = 'Gangguan Sistem Sementara';
const defaultMessage =
  'Kami mengalami gangguan sistem sementara. Silakan coba lagi.';
const defaultCtaButtonLabel = 'Coba lagi';

export default class ErrorResponseScreen extends Component {
  handlePrimaryCta = () => {
    this.props.retry();
  };

  render() {
    const {
      title,
      message,
      hideCtaButton,
      ctaButtonLabel,
      onClickCtaButton: handleClickCtaButton,
      image,
      relativeFill,
    } = this.props.error;

    const containerStyle = relativeFill
      ? styles.containerRelative
      : styles.container;

    return (
      <View style={containerStyle}>
        <View style={styles.centerContainer}>
          <Image
            source={image || temporarySystemDisruptionImage}
            style={styles.image}
            resizeMode="contain"
          />
          <Text style={styles.title}>{title || defaultTitle}</Text>
          <Text style={styles.message}>{message || defaultMessage}</Text>
        </View>
        {!hideCtaButton && (
          <DRNButton
            style={styles.ctaButton}
            buttonStyle={R.style.buttonMainCta}
            text={ctaButtonLabel || defaultCtaButtonLabel}
            onPress={handleClickCtaButton || this.handlePrimaryCta}
          />
        )}
      </View>
    );
  }
}
